/** Whether the store has reviews to display. */
export function hasStoreReviews(reviewCount: number): boolean {
  return reviewCount > 0
}
